import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import AuthLayout from '../layouts/Auth.vue';
import Login from '../views/auth/Login.vue';
import i18n from '../i18n';
import config from '../config/ConfigProvider';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
          title: i18n.t('routes.login'),
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: config.value('basePath'),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters['authentication/loggedIn']) {
    const query = {};
    if (typeof to.query.reauthenticate !== 'undefined') {
      query.reauthenticate = 'auto';
    }

    next({ name: 'login', query });
  }

  next();
});

export default router;
